import { PERMISSIONS, hasPermission } from './permissions';

// Sayfa öncelikleri - kullanıcı hangi sayfaya yönlendirilmeli
const PAGE_PRIORITIES = [
  { path: '/dashboard', permission: PERMISSIONS.DASHBOARD_VIEW, name: 'Dashboard' },
  { path: '/odemeler', permission: PERMISSIONS.PAYMENTS_VIEW, name: 'Ödemeler' },
  { path: '/kampanyalar/genel', permission: PERMISSIONS.CAMPAIGNS_READ, name: 'Kampanyalar' },
  { path: '/kullanicilar', permission: PERMISSIONS.USERS_READ, name: 'Kullanıcı Yönetimi' },
  { path: '/bildirimler', permission: PERMISSIONS.NOTIFICATIONS_READ, name: 'Bildirimler' },
  { path: '/kullanici-rolleri', permission: PERMISSIONS.ROLES_READ, name: 'Rol Yönetimi' },
];

/**
 * Kullanıcının erişebileceği ilk sayfayı bulur
 * @param {Object} user - Kullanıcı objesi
 * @returns {string} - Yönlendirilecek sayfa path'i
 */
export const getDefaultPageForUser = (user) => {
  if (!user) return '/login';
  
  // Kullanıcının erişebileceği ilk sayfayı bul
  for (const page of PAGE_PRIORITIES) {
    if (hasPermission(user, page.permission)) {
      return page.path;
    }
  }
  
  // Hiçbir sayfaya erişimi yoksa dashboard'a yönlendir (yetkisiz erişim mesajı gösterecek)
  return '/dashboard';
};

/**
 * Kullanıcının erişebileceği tüm sayfaları listeler
 * @param {Object} user - Kullanıcı objesi
 * @returns {Array} - Erişilebilir sayfalar listesi
 */
export const getAccessiblePages = (user) => {
  if (!user) return [];
  
  return PAGE_PRIORITIES.filter(page => 
    hasPermission(user, page.permission)
  );
};

export default {
  getDefaultPageForUser,
  getAccessiblePages,
  PAGE_PRIORITIES
};
